import React from 'react';
import { MenuItemStyled } from './menuItem.styled';

export interface MenuItemProps {
  selected?: boolean;
  onClick?: () => void;
  children?: React.ReactChild | React.ReactChild[];
}

const MenuItem = ({ onClick, children, ...rest }: MenuItemProps) => {
  return (
    <MenuItemStyled onClick={onClick} {...rest}>
      {children}
    </MenuItemStyled>
  );
};

export default MenuItem;
